<template>
  <div :class="$style.container">
    <main v-if="!step">
      <p :class="$style.price">
        ￥<span>{{ orderInfo.money && Number(orderInfo.money).toFixed(2) }}</span>
      </p>
      <RadioGroup v-model="payType">
        <CellGroup>
          <Cell clickable @click="payType = '26'">
            <template #title>
              <div :class="$style.payType">
                <img :src="`${$cdnLink}/common/wx.png`" alt="" />
                <span>微信</span>
              </div>
            </template>
            <template #right-icon>
              <Radio name="26" checked-color="#FF650F" />
            </template>
          </Cell>
          <Cell clickable @click="payType = '57'">
            <template #title>
              <div :class="$style.payType">
                <img :src="`${$cdnLink}/common/zfb.png`" alt="" />
                <span>支付宝</span>
              </div>
            </template>
            <template #right-icon>
              <Radio name="57" checked-color="#FF650F" />
            </template>
          </Cell>
        </CellGroup>
      </RadioGroup>
      <p :class="$style.hint">若支付失败，请尝试切换其他支付方式</p>
      <button :class="$style.submit" @click="toCharge">去付款</button>
    </main>
    <main v-if="step == 1" :class="$style.result">
      <img :src="`${$cdnLink}/common/success.png`" alt="" />
      <p>支付成功</p>
      <CellGroup :class="$style.cell">
        <Cell title="支付方式" :value="payType == 26 ? '微信支付' : '支付宝支付'"></Cell>
        <Cell title="实际支付（元）" :value="orderInfo.money && Number(orderInfo.money).toFixed(2)"></Cell>
      </CellGroup>
      <button :class="$style.submit" @click="openBox">去体验云挂机</button>
    </main>
    <main v-if="step == 2" :class="$style.result">
      <img :src="`${$cdnLink}/common/fail.png`" alt="" />
      <p>支付失败</p>
      <CellGroup :class="$style.cell">
        <Cell title="支付方式" :value="payType == 26 ? '微信支付' : '支付宝支付'"></Cell>
        <Cell title="实际支付（元）" :value="orderInfo.money && Number(orderInfo.money).toFixed(2)"></Cell>
      </CellGroup>
      <button :class="$style.submit" @click="rePay">重新支付</button>
      <button :class="$style.cancel" @click="close">暂不开通</button>
    </main>
    <iframe
      id="orderFrame"
      :class="$style.orderFrame"
      name="orderFrame"
      :src="orderIframeLink"
      v-show="orderShow"
      sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation"
    ></iframe>
  </div>
</template>
<script>
import { Cell, CellGroup, Radio, RadioGroup } from 'vant';
import { getPayInfo, onBackApp, onPaySuccess, onClosePage, jumpToNative } from '@/bridge/AppJsBridge';
import { boxPayOrder, boxRenewPayOrder, boxCheckOrder, boxBurn } from '@/api/pay';

export default {
  data() {
    return {
      step: 0, // 0.支付页 1.支付成功 2.支付失败
      payType: '26',
      orderInfo: {},
      orderShow: false,
      orderIframeLink: '',
      cacheUrl: ''
    };
  },
  mounted() {
    this._clientInit();
  },
  methods: {
    _clientInit() {
      getPayInfo((data) => {
        this.orderInfo = JSON.parse(data);
        this.buryReport({
          event: 'cloud_pay_page',
          event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
        })
      });
      onBackApp(async () => {
        const r = await boxCheckOrder({ outOrderSn: this.orderInfo.out_order_sn }, this.orderInfo.token);
        if (r.code == 0 && r.data.paySuccess) {
          this.step = 1;
          this.orderShow = false;
          this.orderIframeLink = '';
          onPaySuccess()
          this.buryReport({
            event: 'cloud_pay_success_page',
            event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
          })
        } else {
          this.step = 2;
          this.orderShow = false;
          this.orderIframeLink = '';
          this.buryReport({
            event: 'cloud_pay_fail_page',
            event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
          })
        }
      })
    },
    back() {},
    async toCharge() {
      const params = {
        goodsId: this.orderInfo.goodsId,
        num: this.orderInfo.num,
        outOrderSn: this.orderInfo.out_order_sn,
        payAppId: this.orderInfo.pay_app_id,
        payType: this.payType,
        callbackUrl: this.orderInfo.callbackUrl,
      };
      try {
        const r = this.orderInfo.userPhoneId
          ? await boxRenewPayOrder({ ...params, userPhoneId: this.orderInfo.userPhoneId }, this.orderInfo.token)
          : await boxPayOrder(params, this.orderInfo.token);    
        if (r.code == 0) {
          if (this.payType != 26) this.orderShow = true;
          this.orderShow = true;
          this.cacheUrl = r.data.payUrl;
          this.orderIframeLink = r.data.payUrl;
        }
        this.buryReport({
          event: 'cloud_pay_page_go_to_pay',
          event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
        }) 
      } catch (error) {
        if (error.response.data.code == 401) {
          this.$toast('登录失效，请重新登录');
        }
        setTimeout(() => {
          jumpToNative(JSON.stringify({
            routePath: 'mine'
          }))
        }, 1500)
      }
    },
    openBox () {
      this.buryReport({
        event: 'cloud_pay_success_page_operate',
        event_field:JSON.stringify({ type: 1}),
      })
      jumpToNative(JSON.stringify({
        routePath: '/cloud/CloudMainActivity'
      }))
      onClosePage(null);
    },
    close() {
      this.buryReport({
        event: 'cloud_pay_fail_page_continue',
        event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
      })
      onClosePage(null);
    },
    rePay() {
      if (this.payType != 26) this.orderShow = true;
      this.orderIframeLink = this.cacheUrl
      this.buryReport({
        event: 'cloud_pay_fail_page_repay',
        event_field:JSON.stringify({ order_sn: this.orderInfo.out_order_sn, order_money: this.orderInfo.money}),
      })
    },
    getCookie(key = "params") {
      let keyReg = key + "=";
      let data = null;
      let cookie = document.cookie;
      let cookieItemArr = cookie.split(";");
      for (const item of cookieItemArr) {
        let curItem = item.trim();
        if (curItem.indexOf(keyReg) === 0) {
          data = curItem.substring(keyReg.length);
        }
      }
      try {
        data = JSON.parse(data);
        return data;
      } catch (error) {
        return data;
      }
    },
    buryReport(data) {
      const params = this.getCookie();
      boxBurn({
        ...params,
        ...data
      })
    }
  },
  components: {
    Cell,
    CellGroup,
    Radio,
    RadioGroup,
  },
};
</script>
<style module lang="scss">
.container {
  header {
    position: relative;
    font-size: 18px;
    height: 50px;
    border-bottom: 1px solid #f8f8f8;
    display: flex;
    justify-content: center;
    align-items: center;
    > span {
      font-weight: 700;
    }
    .icon {
      position: absolute;
      left: 20px;
      top: 13px;
      font-size: 20px;
    }
  }
  main {
    .price {
      text-align: center;
      padding: 50px 0;
      font-size: 22px;
      > span {
        font-weight: 500;
        font-size: 36px;
      }
    }
    .payType {
      display: flex;
      align-items: center;
      font-size: 16px;
      > img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
      }
    }
    .hint {
      color: #939393;
      font-size: 12px;
      margin-bottom: 150px;
      padding-left: 15px;
      margin-top: 15px;
    }
    .submit {
      border: none;
      outline: none;
      width: 238.19px;
      height: 49.65px;
      background: #ff9916;
      border-radius: 25px;
      color: #ffffff;
      font-size: 16px;
      display: block;
      margin: auto;
      margin-bottom: 30px;
      &:active {
        opacity: 0.8;
      }
    }
    .cancel {
      border: 1px solid #ff9916;
      outline: none;
      width: 238.19px;
      height: 49.65px;
      background-color: #ffffff;
      border-radius: 25px;
      color: #ff9916;
      font-size: 16px;
      display: block;
      margin: auto;
      &:active {
        opacity: 0.8;
      }
    }
  }
  .result {
    padding-top: 50px;
    font-size: 18px;
    > img {
      display: block;
      width: 50px;
      height: 50px;
      margin: auto {
        bottom: 20px;
      }
    }
    > p {
      margin-bottom: 50px;
      text-align: center;
    }
    .cell {
      margin-bottom: 100px;
    }
  }

  .orderFrame {
    z-index: 999;
    position: fixed;
    width: 100%;
    min-height: 100%;
    text-align: center;
    background: #f4f4f4;
    margin: auto;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 0;
  }
}
</style>
